import { FETCH_MASJID, FETCH_MASJID_BY_NAME } from "../../ActionType";
import * as API from "../../../ClientAPICalls/index";
import { ChangeSnackbar } from "../SnackbarActions/SnackbarActions";
import { Dispatch } from "redux";
import client from "../../../apolloClient";
import { GET_MASJID_BY_ID } from "../../../graphql/Masjids/query";
import tz_lookup from "tz-lookup";
import { DocumentNode } from "graphql";
import { DEFAULT_JURISTIC, DEFAULT_METHOD_ID, HigherAltitudeMethod, OwnerType, SETTINGS_FIELD } from "../../MasjidTypes";
import { GET_INDIVIDUAL_BY_ID, GET_ORGANIZATION_BY_ID } from "../../../graphql/queries";
import { updateSetting } from "../SettingsActions/SettingsActions";

export const FetchMasjidById =
  (id: string, ownershipType: OwnerType) => async (dispatch: Dispatch<any>) => {
    
    try {
      let query;
      switch (ownershipType) {
        case OwnerType.MASJID:
          query = GET_MASJID_BY_ID;
          break;
        case OwnerType.ORGANIZATION:
          query = GET_ORGANIZATION_BY_ID;
          break;
        case OwnerType.INDIVIDUAL:
          query = GET_INDIVIDUAL_BY_ID;
          break;
        default:
          query = GET_MASJID_BY_ID;
          break;
      }

      // Execute the GraphQL query
      const { data } = await client.query({
        query: query,
        variables: { id },
        fetchPolicy: "network-only",
      });

      if (data && (data.getMasjidById || data.getOrganizationById || data.getIndividualById)) {
        let masjidData = { ...(data.getMasjidById || data.getOrganizationById || data.getIndividualById) };

        // Add timezone information using tz_lookup
        const longitude = masjidData.location.coordinates[0];
        const latitude = masjidData.location.coordinates[1];
        const timezone = tz_lookup(latitude, longitude);
        masjidData.location = { ...masjidData.location, timezone };
        if(data.getOrganizationById || data.getIndividualById){
          masjidData.masjidName = masjidData.name;
          masjidData.masjidProfilePhoto = masjidData.profilePhoto;
          masjidData.masjidPhotos=masjidData.photos;  
          delete masjidData.name;
          delete masjidData.profilePhoto;
          delete masjidData.photos;
        }
        console.log("updating settings", masjidData.metadata);
        // Update settings based on masjid data
        if (ownershipType===OwnerType.MASJID && masjidData.metadata) {
        dispatch(updateSetting(SETTINGS_FIELD.PRAYER_METHOD, masjidData.metadata?.method ?? DEFAULT_METHOD_ID.toString()));
        dispatch(updateSetting(SETTINGS_FIELD.JURISTIC, masjidData.metadata?.juristic ?? DEFAULT_JURISTIC));
        dispatch(updateSetting(SETTINGS_FIELD.SUNRISE_ADJUSTMENT, masjidData.metadata?.sunriseAdjustment ?? 0));
        dispatch(updateSetting(SETTINGS_FIELD.HIGHER_ALTITUDE_METHOD, masjidData.metadata?.higherAltitudeMethod ?? HigherAltitudeMethod.ANGLE_BASED));
        dispatch(updateSetting(SETTINGS_FIELD.HIJRI_ADJUSTMENT, masjidData.metadata?.hijriAdjustment ?? 0));
        }
        // Dispatch the data to the Redux store
        dispatch({ type: "FETCH_ADMIN_MASJID", payload: masjidData });
        
        return masjidData;
      } else {
        throw new Error("Masjid not found");
      }
    } catch (error: any) {
      console.error("Error fetching masjid data:", error);
      return error.response;
    }
  };
